"use strict";

exports.__esModule = true;
exports.LineTrendsSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _Form = require("../../Form");
var _styledComponents = require("styled-components");
var _helper = require("../../Widgets/MeasureChart/helper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LineTrendsSelector = exports.LineTrendsSelector = function LineTrendsSelector(props) {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var elementEditor = props.elementEditor,
    path = props.path,
    itemIndex = props.itemIndex,
    chartItem = props.chartItem;
  var lineTrends = chartItem == null ? void 0 : chartItem.lineTrends;
  var defaultColor = theme.DefaultChartColor || "#1678c2";
  (0, _react.useEffect)(function () {
    if (!lineTrends) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].lineTrends",
          value: el.props.chartItems.props[itemIndex].lineTrends = []
        };
      });
    }
  }, [chartItem, elementEditor, path, itemIndex]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "LineTrendsSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("LineTrendsSelector.lineTrendsOptions.label", "Line trends options")), lineTrends == null ? void 0 : lineTrends.map(function (lineTrend, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "5px"
      },
      key: "LineTrendsSelector-" + index
    }, /*#__PURE__*/_react["default"].createElement(_Form.ColorPicker, {
      "data-testid": "LineTrendsSelector.lineTrendsColor.picker",
      style: {
        width: "45px"
      },
      value: lineTrend.color,
      onChange: function onChange(color) {
        return elementEditor.modifyElementAt(path, function (el) {
          return {
            item: "el.props.chartItems.props[" + itemIndex + "].lineTrends[" + index + "].color",
            value: el.props.chartItems.props[itemIndex].lineTrends[index].color = color
          };
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
      content: translate("LineTrendsSelector.lineTrendYAxis.tooltip", "Y axis value"),
      position: _core.Position.LEFT
    }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
      "data-testid": "LineTrendsSelector.lineTrendYAxisValue.input",
      style: {
        width: "45px"
      },
      onValueChange: function onValueChange(value) {
        return elementEditor.modifyElementAt(path, function (el) {
          return {
            item: "el.props.chartItems.props[" + itemIndex + "].lineTrends[" + index + "].value",
            value: el.props.chartItems.props[itemIndex].lineTrends[index].value = value
          };
        });
      },
      value: lineTrend.value
    })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "LineTrendsSelector.lineTrendRemove.button",
      icon: _icons.IconNames.REMOVE,
      onClick: function onClick() {
        var tempLineTrends = JSON.parse(JSON.stringify(lineTrends));
        tempLineTrends.splice(index, 1);
        elementEditor.modifyElementAt(path, function (el) {
          return {
            item: "el.props.chartItems.props[" + itemIndex + "].lineTrends",
            value: el.props.chartItems.props[itemIndex].lineTrends = tempLineTrends
          };
        });
      }
    }));
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    text: translate("LineTrendsSelector.lineTrendAdd.button", "Add line trend"),
    "data-testid": "LineTrendsSelector.lineTrendAdd.button",
    icon: _icons.IconNames.ADD,
    onClick: function onClick() {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].lineTrends",
          value: el.props.chartItems.props[itemIndex].lineTrends = [].concat(lineTrends, [{
            color: defaultColor,
            value: 0
          }])
        };
      });
    }
  }));
};